export default __webpack_public_path__ + "static/media/royal.e9fecc0d.svg";